import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL } from '../../api';

export const fetchMatches = createAsyncThunk('matches/fetchMatches', async () => {
    try {
        const response = await fetch(`${API_URL}/api/matches`, {
            headers: {
                'Accept': 'application/json',
            }
        });
        
        // Check if the response is OK
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }

        // Validate the content type
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            throw new Error('Received non-JSON response from the server');
        }

        // Parse JSON data
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Fetch Matches Error:', error);
        throw error; // This will trigger the 'rejected' case in Redux
    }
});

const matchesSlice = createSlice({
    name: 'matches',
    initialState: {
        matches: [],
        status: 'idle',
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMatches.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMatches.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.matches = action.payload;
            })
            .addCase(fetchMatches.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export default matchesSlice.reducer;
